import React, {useEffect} from 'react';
import myClass from './Alert.css'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import './Alert.css'
        const variantIcon = {
            success: CheckCircleIcon,
            warning: WarningIcon,
            error: ErrorIcon,
            info: InfoIcon,
        };
const useStyles1 = makeStyles(theme => ({
        success: {
            backgroundColor: green[600],
        },
        error: {
            backgroundColor: theme.palette.error.dark,
        },
        info: {
            backgroundColor: theme.palette.primary.main,
        },
        warning: {
            backgroundColor: amber[700],
        },
        icon: {
            fontSize: 20,
        },
        iconVariant: {
            opacity: 0.9,
            marginRight: theme.spacing(1),
        },
        message: {
            display: 'flex',
            alignItems: 'center',
        }
    }));
function MySnackbarContentWrapper(props) {
    const classes = useStyles1();
    const {className, message, onClose, variant, ...other} = props;
    const Icon = variantIcon[variant];
    return (
            <SnackbarContent
                className={clsx(classes[variant], className)}
                aria-describedby="client-snackbar"
                message={
                        <span id="client-snackbar" className={classes.messag}
                    
                        >
                        <Icon className={clsx(classes.icon, classes.iconVariant)} />
                        {message}
                    </span>
            }
            action={[
                            <IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
                                <CloseIcon className={classes.icon} />
                            </IconButton>,
                    ]}
            {...other}
            />
            );
}

MySnackbarContentWrapper.propTypes = {
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};
const useStyles2 = makeStyles(theme => ({
        margin: {
            margin: theme.spacing(1),
        },
    }));
const theme = createMuiTheme({
    overrides: {
        // MuiSnackbarContent: {
        //     message: {
        width: '70%'
                //     }
                // }
    }
});
const CustomizedSnackbars = (props) => {
    const classes = useStyles2();
    const [open, setOpen] = React.useState(false);
    const [classNames, setClassNames] = React.useState(props.isLogin != null && props.isLogin == true ? "show-login" : "show")

    React.useEffect(() => {
        setTimeout(() => {
            setClassNames("AlertFadeOut")
        }, 3000)
    }, [])

    function handleClick() {
        setOpen(true);
    }

    function handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    }

    return (
            <div className={classNames}>
                <MuiThemeProvider theme={theme}>
                    <Snackbar
                        anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                        open={open}
                        autoHideDuration={6000}
                        onClose={handleClose}
                        >
                        <MySnackbarContentWrapper
                            onClose={handleClose}
                            variant="success"
                            message={props.text}
                            />
                    </Snackbar>
                    {props.variant == 'error' ?
                            <MySnackbarContentWrapper
                                variant="error"
                                className={classes.margin}
                                message={props.text}
                                />
                                : ''}
                    {props.variant == 'warning' ?
                            <MySnackbarContentWrapper
                                variant="warning"
                                className={classes.margin}
                                message={props.text}
                                />
                                : ''}
                    {props.variant == 'info' ?
                            <MySnackbarContentWrapper
                                variant="info"
                                className={classes.margin}
                                message={props.text}
                                />
                                : ''}
                    {props.variant == 'success' ?
                            <MySnackbarContentWrapper
                                variant="success"
                                className={classes.margin}
                                message={props.text}
                                />
                                : ''}
                </MuiThemeProvider>
            </div>
            );
}
export default CustomizedSnackbars